<template>
  <div class="">333</div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped lang=""></style>
